import useAddIdentification from './useAddIdentification'
import useRegisterPatient from './useRegisterPatient'
import { useValidateDni } from './useValidateDni'

export { useAddIdentification, useRegisterPatient, useValidateDni }